module.exports = __webpack_public_path__ + "static/media/Netflix-Logo.3483cbba.png";